import { Component, Input } from '@angular/core';
import { Walk } from '../../shared/models/walk.model';
import { Deal } from '../../shared/models/deal.model';
import { NgIf } from '@angular/common';
import { WalkTileComponent } from '../walks/tile/walk.tile.component';
import { DealTileComponent } from '../deals/tile/deal.tile.component';

@Component({
  selector: 'app-tile',
  templateUrl: 'tile.component.html',
  imports: [NgIf, WalkTileComponent, DealTileComponent],
})
export class TileComponent {
  // Pass data from parent to child with input binding
  @Input() item: object = {};

  isWalk(item: object) {
    return item instanceof Walk;
  }

  isDeal(item: object) {
    return item instanceof Deal;
  }

  asWalk(item: object): Walk {
    return <Walk>item;
  }

  asDeal(item: object): Deal {
    return <Deal>item;
  }
}
